import React from 'react';
import {Button} from 'components/Button';
//import {request} from 'helpers/tools';
import {useToast} from 'helpers/hooks';
import {ReactComponent as Delete} from 'assets/svg/2_delete.svg';
import styles from 'css_modules/Detail.module.css';

export const BulkRemoveButton = ({className, docs, toggleRemove}) => {
    const showToast = useToast();

    const handleClick = async () => {
        if (docs.length===0){
            showToast('Vyberte doklady')
        }
        else{
            toggleRemove(docs)
        }
    }

    return (
        <Button className={styles.flushbutton} onClick={handleClick} style={{ display: 'inline-block', lineHeight: 'normal' }}><Delete /></Button>
    );
};

